import { defineSlotRecipe } from '@chakra-ui/react';

export const switchSlotRecipe = defineSlotRecipe({
  className: 'chakra-switch',
  slots: ['root', 'label', 'indicator', 'control', 'thumb'],
  base: {
    root: {
      display: 'inline-flex',
    },
    label: {
      lineHeight: '1',
      userSelect: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 2,
    },
    control: {
      backgroundColor: 'neutral.700 !important',
      border: '2px solid',
      borderColor: 'neutral.300',
      paddingX: 0.25,
      borderRadius: '0 !important',
      clipPath:
        'polygon(2px 0, calc(100% - 2px) 0, 100% 2px, 100% calc(100% - 2px), calc(100% - 2px) 100%, 2px 100%, 0 calc(100% - 2px), 0 2px) !important',
      overflow: 'hidden',
      _disabled: {
        cursor: 'default !important',
      },
      _checked: {
        borderRadius: '0 !important',
        backgroundColor: 'blue.700 !important',
        borderColor: 'skyBlue',
        '& .topCorners, & .bottomCorners': {
          '&::before, &::after': {
            backgroundColor: 'skyBlue',
          },
        },
      },
      alignItems: 'center',
      display: 'flex',
      transition: 'all 0.2s ease',
      boxShadow: 'none',
      '& .topCorners, & .bottomCorners': {
        position: 'absolute',
        top: 0,
        left: 0,
        boxSize: '100%',
        pointerEvents: 'none',
        '&::before, &::after': {
          content: '""',
          position: 'absolute',
          width: '0.5px',
          height: '0.5px',
          backgroundColor: 'neutral.300',
        },
      },
      '& .topCorners': {
        '&::before': {
          top: 0,
          left: 0,
          clipPath: 'polygon(0 0, 100% 0, 0 100%)',
        },
        '&::after': {
          top: 0,
          right: 0,
          clipPath: 'polygon(100% 0, 0 0, 100% 100%)',
        },
      },
      '& .bottomCorners': {
        '&::before': {
          bottom: 0,
          left: 0,
          clipPath: 'polygon(0 100%, 100% 100%, 0 0)',
        },
        '&::after': {
          bottom: 0,
          right: 0,
          clipPath: 'polygon(100% 0, 100% 100%, 0 100%)',
        },
      },
    },
    thumb: {
      backgroundColor: 'neutral.500 !important',
      border: '2px solid',
      borderColor: 'neutral.300',
      borderRadius: '0 !important',
      clipPath: 'polygon(10% 0, 90% 0, 100% 10%, 100% 90%, 90% 100%, 10% 100%, 0 90%, 0 10%)',
      transition: 'translate 0.2s ease',
      translate: 'none',
      _checked: {
        backgroundColor: 'blue.500 !important',
        borderColor: 'skyBlue',
        borderRadius: '0 !important',
      },
    },
  },
  variants: {
    size: {
      sm: {
        control: {
          width: '34px',
          height: '20px',
        },
        thumb: {
          boxSize: '12px',
        },
      },
      md: {
        control: {
          width: '40px',
          height: '24px',
        },
        thumb: {
          boxSize: '16px',
        },
      },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});
